import { rawTransform } from 'src/services/skuit/utils'
import { Profile } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

export class Profiles {
  api: API

  constructor(api: API) {
    this.api = api
  }

  me = async (config: CustomAxiosConfig = {}): Promise<Profile> => {
    const response = await this.api.get('/accounts/me', config)
    return rawTransform(Profile)(response.data)
  }

  patchMe = async (data: any, config: CustomAxiosConfig = {}): Promise<Profile> => {
    const response = await this.api.patch('/accounts/me', data, config)
    return rawTransform(Profile)(response.data)
  }

  uploadMyPhoto = async (data: any, config: CustomAxiosConfig = {}) => {
    config.headers = { ...config.headers, 'Content-Type': 'multipart/form-data' }
    const response = await this.api.put('/accounts/me/profile-image-upload', data, config)
    return response
  }
}
